import classNames from 'classnames'

import Fixture from '~/components/atoms/Fixture/Fixture'
import Image from '~/components/atoms/Image/Image'
import type { StatProps } from '~/components/atoms/Stat/Stat'
import Stat from '~/components/atoms/Stat/Stat'
import { ComponentTheme } from '~/components/themes'

import Text, { TextSizes } from '../Text/Text'

import styles from './Stats.module.css'

export interface StatsProps {
  stats: StatProps[]
  title?: string
  theme?: ComponentTheme
  verticalPadding?: boolean
  largePaddingBottom?: boolean
  noPaddingBottom?: boolean
  testID?: string
  moduleId?: string
  image?: any
}

export default function Stats({
  stats,
  title,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  largePaddingBottom,
  testID,
  moduleId,
  image,
}: StatsProps) {
  const isVariant = theme === ComponentTheme.black
  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <div
        className={classNames(
          styles.base,
          largePaddingBottom && styles.largePaddingBottom,
          isVariant && styles.baseVariant
        )}
      >
        {image && (
          <div className={styles.leadImageContainer}>
            <Image
              {...image}
              className={styles.leadImage}
              objectFit="contain"
            />
          </div>
        )}
        {title && (
          <Text
            Tag="p"
            size={
              isVariant
                ? TextSizes.primaryTitleLrg
                : TextSizes.secondaryTitleXLrg
            }
            className={styles.title}
          >
            {title}
          </Text>
        )}
        <div className={styles.statsWrap} data-testid={testID}>
          {stats?.map((item, i) => {
            return (
              <Stat
                {...item}
                key={`stat-${i}`}
                className={styles.stat}
                theme={theme}
              />
            )
          })}
        </div>
      </div>
    </Fixture>
  )
}
